import { z } from "zod";

export const playncInfoSchema = z.object({
  email: z.string(),
  emailReception: z.boolean(),
  personName: z.string(),
  phoneNumber: z.string(),
  playncAccountId: z.string(),
  playncId: z.string().optional(),
  smsreception: z.boolean(),
  emailReceptionUpdatedAt: z.string().optional(),
  smsReceptionUpdatedAt: z.string().optional(),
});

export type PlayncInfoType = z.infer<typeof playncInfoSchema>;
